/**
 * Cart upsell "cascade slot" controller.
 *
 * The slot itself is rendered server-side in Liquid (snippets/cart-upsell-slot.liquid)
 * inside the cart-drawer / main-cart-items sections, so it survives every cart re-render.
 * This controller only:
 *   1. binds the "+" via event delegation on document (survives innerHTML swaps),
 *   2. plays the "join the set" beat in place (ports CartCascadeSlot.tsx handleAdd),
 *   3. adds the product to the real cart + re-renders the sections
 *      (mirrors assets/product-complete-set.js for the drawer, assets/cart.js for the page),
 *   4. flashes the graduated cart line + scrolls the fresh slot into view.
 */
(function () {
  if (typeof window.routes === 'undefined' || typeof window.fetchConfig !== 'function') return;
  // Guard against double init (the drawer and the cart page can both enqueue this asset).
  if (window.__wingsCartUpsellInit) return;
  window.__wingsCartUpsellInit = true;

  var PUB_SUB = typeof PUB_SUB_EVENTS !== 'undefined'
    ? PUB_SUB_EVENTS
    : { cartUpdate: 'cart-update', cartError: 'cart-error' };

  /* 700 → 420: klient zgłosił, że potwierdzenie „Dodano do zestawu" trzyma za długo
     i koszyk sprawia wrażenie zaciętego — prosił o skrócenie o 40%. */
  var ADD_DELAY = 420;
  var lastAddedVariantId = null;

  /* Log atrybucji trzymamy w JS, a nie odczytujemy z DOM przy kazdym dodaniu. Powod: na stronie
     /cart sekcje przychodza z odpowiedzi add-to-cart, czyli sprzed naszego zapisu atrybutu —
     odczyt z DOM dalby wartosc nieaktualna i drugi wpis kaskady nadpisalby pierwszy.
     Liquid sluzy tylko jako zasiew przy wejsciu na strone. */
  var attributionLog = null;

  function isReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function haptic(pattern) {
    try {
      if ('vibrate' in navigator && window.matchMedia('(pointer: coarse)').matches && !isReduced()) {
        navigator.vibrate(pattern);
      }
    } catch (e) {}
  }

  function getInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var el = parsed.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function setAddedState(slot, on) {
    slot.classList.toggle('is-added', on);
    var offer = slot.querySelector('[data-upsell-offer]');
    var added = slot.querySelector('[data-upsell-added]');
    var plus = slot.querySelector('.cart-upsell__add-plus');
    var check = slot.querySelector('.cart-upsell__add-check');
    var spark = slot.querySelector('.cart-upsell__spark');
    if (offer) offer.hidden = on;
    if (added) added.hidden = !on;
    if (plus) plus.hidden = on;
    if (check) check.hidden = !on;
    if (spark) spark.hidden = !on;
  }

  function revert(slot) {
    if (!slot) return;
    setAddedState(slot, false);
    delete slot.dataset.busy;
  }

  function publishError(variantId, response) {
    if (typeof publish === 'function') {
      publish(PUB_SUB.cartError, {
        source: 'cart-upsell',
        productVariantId: variantId,
        errors: response.errors || response.description,
        message: response.message,
      });
    }
    if (response && response.message) {
      try { window.alert(response.message); } catch (e) {}
    }
  }

  /* Najblizszy przewijalny przodek. Przewijamy JEGO, a nie okno: karta zyje w szufladzie,
     ktora jest `position: fixed`, wiec `scrollIntoView` potrafi przy okazji przesunac
     stronę pod spodem — niewidoczne przy otwartej szufladzie, widoczne po jej zamknieciu. */
  function nearestScrollable(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      var overflow = window.getComputedStyle(node).overflowY;
      if ((overflow === 'auto' || overflow === 'scroll') && node.scrollHeight > node.clientHeight + 1) {
        return node;
      }
      node = node.parentElement;
    }
    return null;
  }

  /* Karta renderuje sie pod KOTWICA, czyli pod produktem, ktory uruchomil regule. Shopify
     wstawia nowo dodane pozycje na GORE koszyka, wiec z kazdym dodaniem kotwica schodzi
     o jedno miejsce nizej i karta wedruje na dol rosnacej listy. Przy dwoch-trzech dodatkach
     wypada poza widok — to jest zgloszenie klienta "nie widac kolejnych opcji". */
  function scrollSlotIntoView(context) {
    /* Slot wyszukujemy PRZY KAZDEJ probie, nigdy raz na poczatku. Kolejne renderowania
       podmieniaja `innerHTML` szuflady, wiec referencja z pierwszej proby wskazywalaby
       wezel odlaczony od dokumentu — jego `getBoundingClientRect()` to same zera i kod
       przewijalby w losowe miejsce.

       Slot MUSI byc z tego kontekstu, z ktorego dodawalismy. Poprzednia wersja brala
       `document.querySelector`, czyli pierwszy w DOM — a na stronie /cart pierwsza jest
       szuflada, ktora jest ukryta. Przewijanie jej slotu nie robilo nic widocznego. */
    function znajdzSlot() {
      var slots = document.querySelectorAll('[data-cart-upsell]');
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].getAttribute('data-context') === context) return slots[i];
      }
      return slots[0] || null;
    }

    /* Przewijamy NATYCHMIASTOWO, nie plynnie. Lista koszyka zostala przed chwila zbudowana
       od zera, wiec nie ma ciaglosci, ktora plynny przesuw mialby pokazac — a animacja
       gryzlaby sie z ponawianiem ponizej. */
    function wysrodkuj() {
      var biezacy = znajdzSlot();
      if (!biezacy) return;
      try {
        var box = nearestScrollable(biezacy);
        if (!box) { biezacy.scrollIntoView({ block: 'center' }); return; }
        var br = box.getBoundingClientRect();
        var sr = biezacy.getBoundingClientRect();
        if (sr.top >= br.top && sr.bottom <= br.bottom) return; // juz widoczna w calosci
        box.scrollTop = box.scrollTop + (sr.top - br.top) - (box.clientHeight - sr.height) / 2;
      } catch (e) {
        try { biezacy.scrollIntoView(false); } catch (e2) {}
      }
    }

    /* Jednorazowe przewiniecie NIE WYSTARCZA i to jest sedno usterki zgloszonej przez klienta.
       Zmierzone w Chrome: pozycja liczona jest poprawnie i `scrollTop` sie ustawia, ale zaraz
       potem wraca do zera — inne skrypty motywu (m.in. pasek darmowej dostawy) reaguja na
       `cartUpdate` wlasnym renderowaniem i odtwarzaja liste koszyka od nowa. Dlatego
       ponawiamy przez ~1,4 s: kazdy przebieg sprawdza, czy karta jest w calosci widoczna,
       i tylko wtedy nie robi nic. Koszt to kilkanascie porownan prostokatow. */
    var proby = 0;
    function tick() {
      wysrodkuj();
      if (++proby < 12) window.setTimeout(tick, 120);
    }
    /* Dwie klatki na przeliczenie ukladu po podmianie `innerHTML` — sztywne 140 ms
       w poprzedniej wersji bylo zgadywaniem. */
    requestAnimationFrame(function () { requestAnimationFrame(tick); });
  }

  /* Flash the graduated line + bring the fresh slot into view. Both surfaces expose the
     variant id on the quantity input (data-quantity-variant-id). */
  function afterRender(context) {
    if (lastAddedVariantId) {
      try {
        var qty = document.querySelector('[data-quantity-variant-id="' + lastAddedVariantId + '"]');
        var line = qty
          ? (qty.closest('.cart-drawer__item') || qty.closest('.cart-item') || qty.closest('tr'))
          : null;
        if (line) {
          line.classList.add('cart-item--flash');
          window.setTimeout(function () {
            if (line) line.classList.remove('cart-item--flash');
          }, 1000);
        }
      } catch (e) {}
    }
    scrollSlotIntoView(context || 'drawer');
    lastAddedVariantId = null;
  }

  function buildAddConfig() {
    var config = window.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    return config;
  }

  /* Nakłada kupon reguły. Musi iść PO dodaniu produktu — Shopify sprawdza warunki kodu
     względem faktycznej zawartości koszyka. Nie nadpisujemy kodu, który klient wpisał
     samodzielnie: Shopify trzyma jeden kod, więc pierwszeństwo ma wybór klienta. */
  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    var input = document.getElementById('CartDrawer-DiscountInput');
    if (input && input.value && input.value.trim()) return Promise.resolve();

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code }),
    }).catch(function () {});
  }

  /* Dopisuje "<handle reguly>:<variantId>" do atrybutu koszyka `_upsell`. Atrybuty koszyka
     trafiaja do zamowienia jako customAttributes, skad appka liczy zamowienia i przychod
     na regule. Best-effort: kazdy blad jest polykany, bo statystyka nie moze nigdy zablokowac
     dodania produktu do koszyka. */
  function logAttribution(slot, variantId) {
    var handle = slot.getAttribute('data-rule-handle');
    if (!handle) return Promise.resolve();

    if (attributionLog === null) attributionLog = slot.getAttribute('data-upsell-log') || '';

    var entry = handle + ':' + variantId;
    var parts = attributionLog ? attributionLog.split(',') : [];
    if (parts.indexOf(entry) !== -1) return Promise.resolve();
    parts.push(entry);
    var next = parts.join(',');

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _upsell: next } }),
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        attributionLog = (cart && cart.attributes && cart.attributes._upsell) || next;
      })
      .catch(function () {});
  }

  /* ---- Drawer: mirror assets/product-complete-set.js (add → re-fetch section → swap) ---- */
  function addDrawer(slot, variantId, addBtn) {
    var cart = document.querySelector('cart-drawer');
    var config = buildAddConfig();
    if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(addBtn);

    /* CELOWO NIE PROSIMY TU O `sections`.
       Wcześniej to zapytanie dokładało `sections` + `sections_url`, przez co Shopify
       renderował szufladę, dymek koszyka i live-region PO STRONIE SERWERA — a `response.sections`
       nie było potem czytane ani razu (niżej i tak pobieramy świeżą szufladę osobno).
       I musi tak zostać: pomiędzy dodaniem a renderem lecą jeszcze `logAttribution`
       i `applyDiscount`, które zmieniają koszyk, więc sekcje z odpowiedzi `add` byłyby
       nieaktualne — pokazywałyby ceny sprzed naliczenia rabatu zestawowego.
       Zmierzone na żywo 2026-08-18: samo `/cart/add` trwało 941 ms z ~2,2 s całości. */
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    return fetch(window.routes.cart_add_url, { method: 'POST', headers: config.headers, body: formData })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          publishError(variantId, response);
          revert(slot);
          return;
        }
        lastAddedVariantId = String(variantId);
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        return logAttribution(slot, variantId)
          .then(function () { return applyDiscount(slot.getAttribute('data-discount-code')); })
          /* JEDNO zapytanie na obie sekcje zamiast dwóch po kolei.
             Wcześniej szuflada i dymek koszyka leciały osobno, jedno po drugim
             (`?section_id=cart-drawer`, potem `?section_id=cart-icon-bubble`) — czysty
             waterfall, zmierzone 261 ms + 201 ms. Section Rendering API przyjmuje listę
             w `?sections=` i zwraca JSON `{ "nazwa-sekcji": "<html>" }`, więc dostajemy
             obie za cenę jednej podróży. Rozbieranie HTML-a niżej zostaje bez zmian. */
          .then(function () { return fetch(cartUrl + '?sections=cart-drawer,cart-icon-bubble'); })
          .then(function (r) { return r.json(); })
          .then(function (sectionsJson) {
            var html = (sectionsJson && sectionsJson['cart-drawer']) || '';
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var freshDrawer = doc.querySelector('#CartDrawer');
            var currentDrawer = document.querySelector('#CartDrawer');
            /* Podmiana `innerHTML` zeruje scroll kontenera, a na telefonie ucina też trwający
               gest — element pod palcem znika z dokumentu i przewijanie „przeskakuje" na
               stronę pod spodem (zgłoszenie klienta). Pozycję przywracamy po podmianie;
               scrollSlotIntoView i tak potem doceluje, ale bez skoku do zera po drodze. */
            var scrollBox = document.querySelector('#CartDrawer .cart-drawer__body');
            var keepScroll = scrollBox ? scrollBox.scrollTop : 0;
            if (freshDrawer && currentDrawer) currentDrawer.innerHTML = freshDrawer.innerHTML;
            scrollBox = document.querySelector('#CartDrawer .cart-drawer__body');
            if (scrollBox && keepScroll) scrollBox.scrollTop = keepScroll;

            var drawerInner = document.querySelector('cart-drawer .drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');
            var cartDrawerEl = document.querySelector('cart-drawer');
            if (cartDrawerEl) {
              cartDrawerEl.classList.remove('is-empty');
              if (typeof cartDrawerEl.open === 'function') cartDrawerEl.open();
            }

            // Dymek koszyka przyszedł tym samym zapytaniem — bez drugiej podróży do serwera.
            var bubbleHtml = (sectionsJson && sectionsJson['cart-icon-bubble']) || '';
            if (bubbleHtml) {
              var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
              var bubbleSrc = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.body.firstElementChild;
              var bubbleTarget = document.getElementById('cart-icon-bubble');
              if (bubbleSrc && bubbleTarget) bubbleTarget.innerHTML = bubbleSrc.innerHTML;
            }
          })
          .then(function () {
            if (typeof publish === 'function') publish(PUB_SUB.cartUpdate, { source: 'cart-upsell' });
            afterRender('drawer');
          });
      })
      .catch(function () { revert(slot); });
  }

  /* ---- Cart page: mirror assets/cart.js (add with sections → swap each section) ---- */
  function addPage(slot, variantId) {
    var cartItems = document.querySelector('cart-items');
    var config = buildAddConfig();
    var toRender = (cartItems && typeof cartItems.getSectionsToRender === 'function')
      ? cartItems.getSectionsToRender()
      : [];
    var sectionIds = toRender.map(function (s) { return s.section; });

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    return fetch(window.routes.cart_add_url, { method: 'POST', headers: config.headers, body: formData })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          publishError(variantId, response);
          revert(slot);
          return;
        }
        lastAddedVariantId = String(variantId);
        var discountCode = slot.getAttribute('data-discount-code');
        return logAttribution(slot, variantId).then(function () {
          if (discountCode) {
            // Na stronie /cart kupon wymaga przeładowania, żeby sekcje pokazały nowe sumy.
            return applyDiscount(discountCode).then(function () { window.location.reload(); });
          }
          if (response.sections) {
            toRender.forEach(function (section) {
              var container = document.getElementById(section.id);
              if (!container) return;
              var target = container.querySelector(section.selector) || container;
              var sectionHtml = response.sections[section.section];
              if (!sectionHtml) return;
              target.innerHTML = getInnerHTML(sectionHtml, section.selector);
            });
          }
          if (typeof publish === 'function') publish(PUB_SUB.cartUpdate, { source: 'cart-upsell' });
          afterRender('page');
        });
      })
      .catch(function () { revert(slot); });
  }

  /* ---- Click: play the beat, then add after the delay (0 under reduced motion) ---- */
  function onAddClick(slot) {
    if (!slot || slot.dataset.busy) return;
    slot.dataset.busy = '1';

    var addBtn = slot.querySelector('[data-upsell-add]');
    var variantId = slot.getAttribute('data-variant-id');
    var context = slot.getAttribute('data-context') || 'drawer';
    if (!variantId) { delete slot.dataset.busy; return; }

    haptic([10, 30, 14]);
    setAddedState(slot, true);

    window.setTimeout(function () {
      if (context === 'page') addPage(slot, variantId);
      else addDrawer(slot, variantId, addBtn);
    }, isReduced() ? 0 : ADD_DELAY);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-upsell-add]');
    if (!btn) return;
    var slot = btn.closest('[data-cart-upsell]');
    if (!slot) return;
    e.preventDefault();
    onAddClick(slot);
  });

  /* ---- Strażnik osieroconego kuponu --------------------------------------------------
     Kupon reguły to zwykły kod rabatowy, a Shopify nie umie warunkować kodu obecnością
     konkretnego produktu w koszyku — potrafi tylko minimalną kwotę albo ilość. Raz nałożony
     kod zostawał więc także po usunięciu walizki, do której był dobrany. Zgłoszenie klienta:
     „nie znikają promocyjne ceny jak usuniesz bazowy produkt".

     Liquid wystawia w `[data-cart-upsell-guard]` dwie wartości: kod, który POWINIEN
     obowiązywać przy obecnej zawartości koszyka (pusty, gdy żadna reguła nie pasuje),
     oraz listę wszystkich kodów upsellowych sklepu. Kod z tej listy, który nie jest kodem
     oczekiwanym, jest osierocony i schodzi.

     Kodów spoza tej listy NIE ruszamy. Kupon wpisany przez klienta musi zostać —
     to ta sama zasada, którą trzyma `applyDiscount`.

     To łatka, nie docelowe rozwiązanie. Docelowo rabat ma być automatyczny (Shopify
     Function), bo wtedy nie ma kodu, który mógłby osierocieć albo wyciec. */
  var GUARD_NOTE_FLAG = 'wingsUpsellGuardNote';

  /* Zdejmuje WSZYSTKIE kody z koszyka. Bezpieczne tylko dlatego, że Shopify trzyma
     w koszyku dokładnie jeden kod — sprawdzone: wpisanie drugiego zastępuje pierwszy.
     Zwraca listę kodów, które zostały PO operacji, żeby wywołujący mógł potwierdzić skutek
     zamiast zakładać, że się udało. */
  function clearDiscount() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart && cart.discount_codes ? cart.discount_codes : [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; });
      })
      .catch(function () { return null; });
  }

  function revealNotes() {
    var notes = document.querySelectorAll('[data-upsell-guard-note]');
    for (var i = 0; i < notes.length; i++) notes[i].hidden = false;
  }

  /* ---- Wyjaśnienie, gdy pozycja STRACIŁA rabat zestawowy -------------------------------
     Klient prosił o komunikat wprost: „jak zrzuci te ceny, że usunięty został produkt bazowy,
     stąd cena wraca". Przy kuponie wywoływało go zdjęcie kodu. Przy rabacie automatycznym
     nie ma kodu do zdjęcia — rabat po prostu przestaje się liczyć — więc komunikat musi
     wynikać z samej ZMIANY: pozycja, która miała rabat zestawowy, już go nie ma.

     Dlatego trzymamy w sesji zdjęcie stanu: które linie koszyka miały rabat upsellowy.
     Rozpoznajemy je po nazwie rabatu z `data-known-titles`, żeby nie reagować na zniknięcie
     rabatu, który nie jest nasz — np. kodu, który klient sam wpisał i sam usunął.

     Ta ścieżka działa dla OBU mechanizmów, więc przeżyje wygaszenie kuponów. */
  var SNAPSHOT_KEY = 'wingsUpsellDiscountSnapshot';

  /* ---- Sprzątanie śladu atrybucji --------------------------------------------------
     `_upsell` ma odzwierciedlać koszyk, nie historię klikania. Klient zobaczył w adminie
     zamówienie z wpisem atrybucji bez produktu (kupujący dodał i usunął przed zapłatą)
     i zgłosił to jako błąd zliczania. Raport wpisy bez pokrycia i tak odfiltrowuje —
     to sprzątanie jest dla człowieka patrzącego w atrybuty zamówienia.

     Wpis w nieznanym formacie (bez dwukropka) zostaje — nie kasujemy, czego nie
     rozumiemy. Lustro tej reguły: `pruneUpsellValue` w appce
     (shared/models/checkoutOffersConfig.ts) — przykasa czyści identycznie. */
  var pruneBusy = false;
  function pruneAttribution(cart) {
    try {
      if (pruneBusy) return;
      var raw = cart && cart.attributes && cart.attributes._upsell;
      if (!raw) return;
      var inCart = {};
      (cart.items || []).forEach(function (item) { inCart[String(item.variant_id)] = 1; });
      var parts = String(raw).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var kept = parts.filter(function (entry) {
        var sep = entry.indexOf(':');
        if (sep === -1) return true;
        return !!inCart[entry.slice(sep + 1)];
      });
      if (kept.length === parts.length) return;
      pruneBusy = true;
      var next = kept.join(',');
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(cartUrl + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _upsell: next } }),
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          /* Pamięć podręczna logu atrybucji musi zobaczyć nową wartość — inaczej
             następne dodanie odtworzyłoby skasowane wpisy z nieświeżej kopii. */
          attributionLog = (c && c.attributes && c.attributes._upsell) || next;
        })
        .catch(function () {})
        .then(function () { pruneBusy = false; });
    } catch (e) {}
  }

  function noteIfDiscountLost(guard) {
    var titles = (guard.getAttribute('data-known-titles') || '')
      .split('|')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Sprzątanie jedzie na koszyku z TEGO samego fetcha co nota — jeden spójny
           stan, zero dodatkowych zapytań na każdą zmianę koszyka. */
        pruneAttribution(cart);
        if (!titles.length) return;
        /* Kluczujemy po `variant_id`, NIE po `item.key`. Klucz linii zawiera hash, który
           zmienia się razem z rabatem na tej linii — pierwsza wersja porównywała po `key`
           i dlatego nigdy nie wykrywała utraty: stary klucz nie istniał już w koszyku.
           Sprawdzone na żywym koszyku: `52714402414934:12becf9a…` → `52714402414934:d0bab0e9…`
           przy tym samym wariancie.

           Cena kluczowania po wariancie: dwie linie z tym samym wariantem, ale różnymi
           właściwościami, zliczą się jako jedna. Dla tego zastosowania nieszkodliwe. */
        var items = cart.items || [];
        var teraz = {};
        var wKoszyku = {};
        items.forEach(function (item) {
          var id = String(item.variant_id);
          wKoszyku[id] = 1;
          var nasze = (item.line_level_discount_allocations || []).filter(function (a) {
            var t = a.discount_application && a.discount_application.title;
            return t && titles.indexOf(t) !== -1;
          });
          if (nasze.length) teraz[id] = 1;
        });

        var poprzednio = {};
        try {
          poprzednio = JSON.parse(window.sessionStorage.getItem(SNAPSHOT_KEY) || '{}') || {};
        } catch (e) {}

        // Straciła rabat = miała go, nadal jest w koszyku, a teraz go nie ma.
        var stracila = Object.keys(poprzednio).some(function (key) {
          return wKoszyku[key] && !teraz[key];
        });

        try {
          window.sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(teraz));
        } catch (e) {}

        if (stracila) revealNotes();
      })
      .catch(function () {});
  }

  /* Odświeża szufladę bez przeładowania strony — ta sama ścieżka, którą po dodaniu produktu
     idzie `addDrawer`.
     Stan otwarcia zapisujemy PRZED podmianą i przywracamy tylko wtedy, gdy szuflada była
     otwarta. Bezwarunkowe `open()` rozwijałoby ją klientowi, który jej wcale nie otwierał.
     Notę odsłaniamy PO podmianie, bo podmiana HTML kasuje wcześniejsze odsłonięcie. */
  function refreshDrawer() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var el = document.querySelector('cart-drawer');
    var wasOpen = !!(el && el.classList.contains('active'));
    return fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        // Ta sama ochrona scrolla co w addDrawer — patrz komentarz tam.
        var scrollBox = document.querySelector('#CartDrawer .cart-drawer__body');
        var keepScroll = scrollBox ? scrollBox.scrollTop : 0;
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        scrollBox = document.querySelector('#CartDrawer .cart-drawer__body');
        if (scrollBox && keepScroll) scrollBox.scrollTop = keepScroll;
        revealNotes();
        var drawer = document.querySelector('cart-drawer');
        if (wasOpen && drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () {});
  }

  /* Świeżość danych, a nie znacznik na elemencie.

     Poprzednia wersja czytała oczekiwany kod z atrybutu w DOM i pilnowała jednokrotności
     znacznikiem ustawianym na tym elemencie. Oba założenia były błędne. Dawn po usunięciu
     pozycji przerysowuje sekcję szuflady, ale NIE wiersz strażnika w tabeli na /cart —
     zostawał tam element z kodem sprzed usunięcia i z już ustawionym znacznikiem. Ponieważ
     miał pierwszeństwo, strażnik odbijał się od niego i nie robił nic.

     To dokładnie to, co zgłosił klient: „po usunięciu głównego produktu zostają zniżki
     na wszystkim". Zreprodukowane kliknięciem kosza: strażnik szufladowy był świeży i miał
     poprawny kod, stronowy był przestarzały i wygrywał.

     Teraz oczekiwany kod bierzemy ze ŚWIEŻO pobranej sekcji, więc wynik nie zależy od tego,
     który element Dawn zdecyduje się wymienić. Jednokrotność pilnuje pamięć zdjętych kodów
     plus blokada współbieżności — bez opierania się o stan DOM. */
  var guardBusy = false;
  var guardCleared = {};

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname || '');
  }

  /* Kod, który POWINIEN obowiązywać przy aktualnej zawartości koszyka — wprost z serwera. */
  function freshExpectedCode() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('[data-cart-upsell-guard]');
        return g ? (g.getAttribute('data-expected-code') || '').trim() : null;
      })
      .catch(function () { return null; });
  }

  function stripOrphanDiscount() {
    if (guardBusy) return;
    var guard = document.querySelector('[data-cart-upsell-guard]');
    if (!guard) return;
    var known = (guard.getAttribute('data-known-codes') || '').split(',').map(function (s) {
      return s.trim();
    }).filter(Boolean);
    if (!known.length) return;

    guardBusy = true;
    Promise.all([
      fetch('/cart.js').then(function (r) { return r.json(); }),
      freshExpectedCode(),
    ])
      .then(function (res) {
        var cart = res[0];
        var expected = res[1];
        // Nie wiemy, co powinno obowiązywać — lepiej nie ruszać niż zdjąć rabat na oślep.
        if (expected === null) return null;

        var applied = (cart.discount_codes || []).filter(function (d) {
          return d.applicable;
        }).map(function (d) { return d.code; });

        var orphan = applied.filter(function (code) {
          return known.indexOf(code) !== -1 && code !== expected && !guardCleared[code];
        });
        if (!orphan.length) return null;

        orphan.forEach(function (code) { guardCleared[code] = 1; });

        return clearDiscount().then(function (left) {
          // Nie udało się zdjąć — nie ruszamy widoku. Kolejna zmiana koszyka spróbuje znowu.
          if (left === null) return null;
          var stillThere = left.filter(function (code) { return orphan.indexOf(code) !== -1; });
          if (stillThere.length) return null;

          /* Poza /cart przerysowujemy szufladę, bo przeładowanie zamknęłoby ją klientowi
             pod palcami. Na /cart nie ma czego zamykać, a przeładowanie jest najprostszą
             drogą do przeliczonej tabeli — komunikat wraca z flagi w sesji.
             O kontekście decyduje adres strony, nie atrybut na elemencie, który bywa stary. */
          if (!onCartPage()) return refreshDrawer();
          try { window.sessionStorage.setItem(GUARD_NOTE_FLAG, '1'); } catch (e) {}
          window.location.reload();
          return null;
        });
      })
      .catch(function () {})
      .then(function () { guardBusy = false; });
  }

  /* Odsłania wyjaśnienie po przeładowaniu — klient prosił, żeby powiedzieć wprost,
     dlaczego cena wróciła do standardowej, a nie zostawiać go z samą zmianą kwoty. */
  function showGuardNote() {
    var flag = null;
    try { flag = window.sessionStorage.getItem(GUARD_NOTE_FLAG); } catch (e) {}
    if (!flag) return;
    try { window.sessionStorage.removeItem(GUARD_NOTE_FLAG); } catch (e) {}
    revealNotes();
  }

  /* Usunięcie pozycji przerysowuje sekcje koszyka AJAX-em, bez przeładowania strony, więc
     jednorazowe sprawdzenie przy wejściu nie wystarczy. Obserwator DOM jest tu celowo
     zamiast podpięcia się pod pub-sub motywu: działa niezależnie od tego, którą ścieżką
     motyw przerysuje koszyk. Świeży element strażnika nie ma znacznika `upsellChecked`,
     więc każdy przerysowany koszyk jest sprawdzany raz. */
  /* Kolejność jest istotna: najpierw sprawdzamy utratę rabatu, potem zdejmujemy osierocony
     kupon. Odwrotnie zdjęcie kuponu zmieniłoby stan, zanim zdążylibyśmy zapisać, że pozycja
     rabat MIAŁA — i komunikat by nie wyszedł. */
  function runGuard() {
    // Dowolny strażnik wystarczy: nazwy rabatów i lista kodów nie zależą od zawartości
    // koszyka, a oczekiwany kod `stripOrphanDiscount` pobiera świeżo z serwera.
    var guard = document.querySelector('[data-cart-upsell-guard]');
    if (!guard) return;
    noteIfDiscountLost(guard);
    stripOrphanDiscount();
  }

  /* KOSZT, ZMIERZONY 2026-08-18 — zanim ktoś znów będzie szukał, czemu dodanie „trwa".
     Obserwator wisi na całym `document.body`, więc KAŻDE przerysowanie koszyka (także to,
     które przed chwilą zrobiliśmy sami w `addDrawer`) odpala go ponownie. Do czasu
     kliknięcia dokłada to: 250 ms tego debounce'u + pełne `?section_id=cart-drawer`
     ze `stripOrphanDiscount` (~357 ms) + `/cart.js`. To duplikat renderu, który już mamy.
     NIE OPTYMALIZOWAĆ TEGO W BIEGU: to jest strażnik osieroconego kuponu, ma znaną
     ślepą plamkę (kaskada karmi własny wyzwalacz), a pochopne wycięcie duplikatu
     zostawi klientowi kupon na produkt, którego nie ma już w koszyku. Jeśli kiedyś
     to skracać, to razem z testem na scenariusz „usuń produkt bazowy przy aktywnym
     rabacie zestawowym", a nie samym stoperem. Dodanie i tak pokazuje się kupującemu
     wcześniej — szuflada podmienia się zaraz po scaleniu sekcji (~1,0 s od kliknięcia). */
  var guardTimer = null;
  function scheduleGuard() {
    if (guardTimer) window.clearTimeout(guardTimer);
    guardTimer = window.setTimeout(function () {
      guardTimer = null;
      runGuard();
    }, 250);
  }

  function initGuard() {
    showGuardNote();
    runGuard();
    if (typeof window.MutationObserver !== 'function') return;
    new window.MutationObserver(scheduleGuard).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGuard);
  } else {
    initGuard();
  }
})();
